class StorageService {
    /**
     * Return the default storage key  or throws an error if
     * not implemented.
     *
     * @returns {String} The default storage key.
     */
    static get key() {
        throw new Error("Resource getter not defined.");
    }
    static isLocalStorageAvailable(){
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }

    static getFromLocalStorage (key) {
        if(this.isLocalStorageAvailable()) {
            return localStorage.getItem(key);
        }
        else {
            return null;
        }
    }

    static setIntoLocalStorage(key, value) {
        if(this.isLocalStorageAvailable()) {
            localStorage.setItem(key, value);
        }
    }

    static removeFromLocalStorage(key) {
        if(this.isLocalStorageAvailable()) {
            localStorage.removeItem(key);
        }
    }
}

export default StorageService;